import { ComponentProps, ContextType, RefObject } from 'preact';
import type { TabBarContext, TabBarLayout } from '../UNSAFE_TabBarCommon';

import { useTabBar } from '../hooks/PRIVATE_useTabBar';

type TabBarContextValue = ContextType<typeof TabBarContext>;

export type useTabBarOptions = {
  class?: string;
  display?: TabBarContextValue['display'];
  edge?: 'bottom' | 'top';
  onRemove?: TabBarContextValue['onRemove'];
  onSelect?: TabBarContextValue['onSelect'];
  ref?: RefObject<HTMLDivElement>;
  selection?: TabBarContextValue['selection'];
  size?: TabBarContextValue['size'];
  children?: ComponentProps<typeof TabBarLayout>['children'];
};

/**
 * A thin wrapper around useTabBar hook
 */
export function useTabBarMixed(options: useTabBarOptions) {
  return useTabBar(options);
}
